import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./FriendInfo.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../../Styleds";
import CloseIcon from '@mui/icons-material/Close';
import ImageLoader from "./ImageLoader";
/* ./assets/ui/userIcon_0.png */
const FriendInfo = ({ type = 1, user , onClick, onDel }) => {
    useEffect(()=>{
    },[])
    return (
        <>
            {type === 1 &&
                <div className={style.user} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.icon}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.user_avatar} />
                    </div>
                    <div className={style.info}>
                        <YStyled.Span size={17} >{user.user_name}</YStyled.Span>
                        <YStyled.Span size={11} >{user.user_username}</YStyled.Span>
                    </div>
                </div>
            }
            {type === 2 &&
                <div className={style.user2} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.avatar}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.users_avatar} />
                        {onDel &&
                            <div className={style.del} onClick={e => { onDel() }}>
                                <CloseIcon />
                            </div>
                        }
                    </div>
                    <YStyled.Span size={13} >{user.user_name}</YStyled.Span>
                </div>
            }
            {type === 3 &&
                <div className={style.user} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.icon}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.users_avatar} />
                    </div>
                    <div className={style.info}>
                        <YStyled.Span size={15} >{user.user_name}</YStyled.Span>
                    </div>
                </div>
            }
            {type === 4 &&
                <div className={style.user} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.icon}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.users_avatar} />
                    </div>
                    <div className={style.info}>
                        <YStyled.Span size={15} >{user.user_name}</YStyled.Span>
                        <YStyled.Label style={{ padding: ".3rem .6rem" }}>
                            <YStyled.Span size={13} style={{ color: "#888888" }}>邀請中</YStyled.Span>
                        </YStyled.Label>
                    </div>
                </div>
            }
            {type === 5 &&
                <div className={style.user5} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.icon}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.user_avatar} />
                    </div>
                    <div className={style.info}>
                        <YStyled.Span color="#71532d" fontWeight={400} size={17} >{user.user_name}</YStyled.Span>
                        <YStyled.Span size={11} >{user.user_username}</YStyled.Span>
                    </div>
                </div>
            }
            {type === 6 &&
                <div className={style.user} onClick={
                    e => {
                        if (onClick)
                            onClick();
                    }
                }>
                    <div className={style.icon}>
                        <ImageLoader variant={"circular"} width={"100%"} height={"100%"} src={user.user_avatar} />
                    </div>
                    <div className={style.info}>
                        <YStyled.Span size={17} >{user.user_name}</YStyled.Span>
                        <YStyled.Span size={11} >{`@${user.user_username}`}</YStyled.Span>
                    </div>
                </div>
            }
        </>
    );
}

export default FriendInfo;